export default __webpack_public_path__ + "static/media/Rats_ Guide To Survival.c9abf539.png";